import { render } from "./ItemCase.vue?vue&type=template&id=af2163ea&scoped=true&ts=true"
import script from "./ItemCase.vue?vue&type=script&lang=ts"
export * from "./ItemCase.vue?vue&type=script&lang=ts"

import "./ItemCase.vue?vue&type=style&index=0&id=af2163ea&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af2163ea"]])

export default __exports__